// @flow
import { createSelector } from 'reselect';
import pipe from 'ramda/es/pipe';
import filter from 'ramda/es/filter';
import map from 'ramda/es/map';
import isEmpty from 'ramda/es/isEmpty';
import values from 'ramda/es/values';

import { getFIO } from 'app/common/lib/names';


/**
 * Возвращает массив учеников, как цели для выдачи товара.
 * Если приложение не является личным кабинетом родителей,
 * возвращает null.
 * Если не найдены ученики со школами соответствующими точке выдачи,
 * тоже возвращает null.
 */

const selectStudentsAsReceivers = createSelector(
  [
    state => state.students.data,
    (_, { deliveryPointUuid }) => deliveryPointUuid,
  ],
  (data, deliveryPointUuid) => {
    const items = pipe(
      values,
      filter(({ shopUuid }) => shopUuid === deliveryPointUuid),
      map(({ name, userUuid }) => ({
        name: getFIO(name),
        user_uuid: userUuid,
      })),
    )(data);
    return isEmpty(items) ? null : items;
  },
);

export default (state: Object, props: { deliveryPointUuid: string }) => {
  if ((process.env.APP_NAME || process.env.REACT_APP_NAME) !== 'cabinet') return null;

  return selectStudentsAsReceivers(state, props);
};
